<template>
  <div
    class="predictive-search container grid"
    :class="$class('loading')"
  >
    <div class="predictive-search__panel col xs6 l2-4">
      <p
        class="predictive-search__title text-label-s"
        v-text="$string('search.popular_searches')"
      />

      <ul class="predictive-search__suggestions">
        <li
          v-for="(_, index) of [1, 2, 3, 4]"
          :key="`suggestion-${index}`"
          class="predictive-search__suggestion-item"
        >
          <div
            class="
              predictive-search__suggestion
              text-body-xs
              text-body-s-desktop
            "
            v-text="$string('accessibility.loading')"
          />
        </li>
      </ul>
    </div>

    <div
      class="
        predictive-search__panel
        predictive-search__products-panel
        col xs6 l5-11
      "
    >
      <p
        class="predictive-search__title text-label-s"
        v-text="$string('search.trending_products')"
      />

      <div class="predictive-search__products-container">
        <div class="predictive-search__products">
          <product-card
            v-for="(_, index) of [false, false, false, false]"
            :key="`product-${index}`"
            block-class="predictive-search"
            :index="index"
            :product="false"
            tiny
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Predictive search loading (predictive-search)
 * -----------------------------------------------------------------------------
 * Predictive search results loading state.
 *
 */
import ProductCard from '~async/product-card/product-card'

export default {
  name: 'PredictiveSearchLoading',

  components: {
    ProductCard,
  },
}
</script>
